module.exports = __webpack_public_path__ + "img/微课05.78d49661.svg";